import { HttpClient } from "../HttpClient";

export const PostApplyEarlyPay = async (formData) => {
  try {
    console.log("🔍 PostApplyEarlyPay - FormData entries:");
    for (let [key, value] of formData.entries()) {
      console.log(`  ${key}:`, value instanceof File ? `File(${value.name})` : value);
    }
    
    const { data } = await HttpClient.post("api/subscriptions", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
    console.log("✅ PostApplyEarlyPay response:", data);
    return data;
  } catch (err) {
    console.error("❌ PostApplyEarlyPay error:", err);
    return Promise.reject(err);
  }
};
// export const PostApplyEarlyPay = async (formData) => {
//   try {
//     const { data } = await HttpClient.post("api/subscriptions", formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return data;
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
